import * as React from 'react';
import styled from 'styled-components';
import MuiInputLabel, { InputLabelProps as MuiInputLabelProps } from '@material-ui/core/InputLabel';

const StyledInputLabel: typeof MuiInputLabel = styled(MuiInputLabel)``;

export type DSInputLabelProps = MuiInputLabelProps;
export const DSInputLabel: React.FC<DSInputLabelProps> = props => <StyledInputLabel {...props} />;
DSInputLabel.displayName = 'DSInputLabel';
